import React from "react";
import { Typography, Box } from "@mui/material";

interface OperationDateProps {
    date: string | null | undefined;
    label?: string;
    labelVariant?: 'subtitle2' | 'caption';
}

const formatCustomDate = (timestamp: string): string => {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return 'Invalid Date';
    
    const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    const day = date.getDate();
    const year = date.getFullYear();
    
    return `${weekday}. ${month}. ${day} ${year}`;
};

const formatCustomTime = (timestamp: string): string => {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return 'Invalid Time';
    
    return new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    }).format(date);
};

const OperationDate: React.FC<OperationDateProps> = ({ date, label, labelVariant = 'subtitle2' }) => {
    // Return null if no date is provided (for conditional rendering)
    if (!date) {
        return null;
    }

    return (
        <Box>
            { label !== undefined &&
                <Typography
                    component="p"
                    variant={labelVariant}
                    sx={{
                        color: "text.primary",
                        fontWeight: 400
                    }}>{label}</Typography>
            }
            <Typography
                variant="h6"
                component="p"
                sx={{
                    color: "text.secondary",
                    my: -0.5
                }}>{formatCustomDate(date)}</Typography>
            <Typography variant="body1" sx={{
                color: "text.secondary"
            }}>{formatCustomTime(date)}</Typography>
        </Box>
    );
};

export default OperationDate;
